import { BinIcon } from "../../../../components/icon/Icon";

function LiteTradeNotificationCloseButton(props) {
    const {closeToast} = props;

    return <div className="p-1 notification-close-button" onClick={closeToast}>
        <BinIcon name="IcClose" style={{fill: 'var(--color-white-60)'}}/>
    </div>
}

export default LiteTradeNotificationCloseButton;
